<template>
  <v-menu
    transition="scale-transition"
    v-model="localValue"
    :close-on-content-click="false"
    :activator="element"
    max-width="350"
  >
    <v-card
      color="grey lighten-4"
      flat
    >
      <v-toolbar
        :color="this.getEventColor(agendamento)"
        dark
      >
        <v-toolbar-title v-html="agendamento.name"></v-toolbar-title>
        <v-spacer></v-spacer>
        <tw-agendamento-cadastro
          :agendamento="agendamento.agenda"
          @update="onUpdate"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </tw-agendamento-cadastro>
        <template v-if="!this.cancelamento">
          <tw-cadastro-cancelar-agendamento
            :agendamento="this.agendamento.agenda"
            :data="this.dia"
            :hora-inicio="this.horaInicio"
            :hora-fim="this.horaFim"
            @update="onUpdate"
          >
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
          </tw-cadastro-cancelar-agendamento>
        </template>
        <v-tooltip top v-if="this.cancelamento">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              tooltip="Remover cancelamento"
              icon
              @click="onClickRemoveCancelamento()"
            >
              <v-icon>mdi-undo-variant</v-icon>
            </v-btn>
          </template>
          <span>Desfazer cancelamento</span>
        </v-tooltip>
        <v-menu
          :close-on-content-click="true"
          bottom
          left
          offset-y
        >
          <template v-slot:activator="{ on, attrs}">
            <v-btn icon
                   v-bind="attrs"
                   @click.stop.prevent=""
                   v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <tw-cadastro-cliente :cliente="this.cliente" @update="this.onUpdate">
                <template v-slot:activator="{ on }">
                  <v-list-item-group>
                    <v-list-item link v-on="on">
                      <v-list-item-icon>
                        <v-icon>mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Editar cliente</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </template>
              </tw-cadastro-cliente>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar>
      <tw-calendario-conteudo
        :agendamento="this.agendamento"
        :cancelamento="this.cancelamento"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          color="secondary"
          @click="localValue = false"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
    <tw-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import AgendamentoCadastro from '@/modules/agendamento/cadastro/AgendamentoCadastro.vue';
import CadastroCliente from '@/modules/cliente/CadastroCliente.vue';
import CadastroCancelarAgendamento from '@/modules/cancelamento/CadastroCancelarAgendamento.vue';
import CancelamentoService from '@/api/cancelamento-service';
import calendarioMixin from '@/modules/calendario/calendario-mixin';
import CalendarioConteudo from '@/modules/calendario/CalendarioConteudo.vue';

export default {
  mixins: [calendarioMixin],
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    element: {
      required: true,
    },
    agendamento: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loading: false,
    dialog: false,
  }),
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      if (newValue) {
        this.getAgendamento();
      }
    },
  },
  methods: {
    onUpdate() {
      this.$emit('update', this.filters);
    },
    onClickRemoveCancelamento() {
      this.$refs.confirm.open('Você deseja desfazer o cancelamento?',
        'O cancelamento será removido e esta operação não pode ser desfeita.',
        { width: 500 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          CancelamentoService.remove(this.cancelamento.id)
            .then(this.onUpdate);
        });
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
    cliente: {
      get() {
        if (this.agendamento && this.agendamento.agenda) {
          return this.agendamento.agenda.cliente;
        }
        return null;
      },
    },
    dia: {
      get() {
        if (this.agendamento && this.agendamento.agenda) {
          return this.agendamento.agenda.dia;
        }
        return null;
      },
    },
    horaInicio: {
      get() {
        if (this.agendamento && this.agendamento.agenda) {
          return this.agendamento.agenda.horaInicio;
        }
        return null;
      },
    },
    horaFim: {
      get() {
        if (this.agendamento && this.agendamento.agenda) {
          return this.agendamento.agenda.horaFim;
        }
        return null;
      },
    },
    cancelamento: {
      get() {
        if (this.agendamento && this.agendamento.cancelamento) {
          return this.agendamento.cancelamento;
        }
        return null;
      },
    },
  },
  components: {
    TwCalendarioConteudo: CalendarioConteudo,
    TwCadastroCliente: CadastroCliente,
    twAgendamentoCadastro: AgendamentoCadastro,
    twCadastroCancelarAgendamento: CadastroCancelarAgendamento,
  },
};
</script>
